"use client";

import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing24, accentColorLink, textColorPrimary, lineHeightTight } from "@churchofjesuschrist/eden-style-constants";
import { H4 } from "@churchofjesuschrist/eden-headings";
import { ChevronDown as ChevDown } from "@churchofjesuschrist/eden-icons";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Chevron = styled(ChevDown).withConfig({
  componentId: "sc-1rgj0tw-0"
})(["position:relative;line-height:", ";details[open] > summary &&{transform:rotate(180deg);}"], lineHeightTight);
const HandleOuter = styled.summary.withConfig({
  componentId: "sc-1rgj0tw-1"
})(["display:block;cursor:pointer;color:", ";margin-block-end:0;transition:margin-block-end 80ms ease-out;width:100%;list-style:none;&::-webkit-details-marker{display:none;}details[open] > &&{text-decoration:none;color:", ";margin-block-end:", ";transition:margin-block-end 80ms ease-in;}> .innerWrapper{display:flex;justify-content:space-between;align-items:center;padding:", ";}"], accentColorLink, textColorPrimary, spacing24, spacing24);
const Title = styled(H4).withConfig({
  componentId: "sc-1rgj0tw-2"
})(["display:inline-block;margin:0;text-align:start;width:100%;"]);

/**
 * The element that summarizes what is within the [`Drawer`](/components/eden-drawer) component.
 */
const Summary = ({
  children,
  ...props
}) => /*#__PURE__*/_jsx(HandleOuter, {
  ...props,
  children: /*#__PURE__*/_jsxs("div", {
    className: "innerWrapper",
    children: [/*#__PURE__*/_jsx(Title, {
      renderAs: "div",
      children: children
    }), /*#__PURE__*/_jsx(Chevron, {
      size: "1.5rem"
    })]
  })
});
Summary.displayName = "Summary";
Summary.propTypes = {
  /** Contents rendered inside the Summary */
  children: PropTypes.node.isRequired
};
export default Summary;